import React from 'react'

const Stats=[
    {count :"5K", label:"Active Students"},
    {count :"10+", label:"Mentors"},
    {count :"200+", label:"Courses"},
    {count :"50+", label:"Awards"},
]

const StatsComponent = () => {
  return (
   <section>
    <div>
        <div className=' w-full flex gap-x-20 justify-center bg-richblack-700 ' >
            {
                Stats.map((data,index)=>{
                    return(
                        <div key={index}>
                            <h1 className='text-white'>{data.count}</h1>
                            <h2 className='text-base font-medium text-richblack-300'>{data.label}</h2>
                        </div>
                    )
                })
            }
        </div>
    </div>
   </section>
  )
}

export default StatsComponent